export const sliderItems = [
  {
    id: 1,
    img: require('./images/home/img1.png'),
    title: 'SUMMER SALE',
    desc: "DON'T COMPROMISE ON STYLE! GET FLAT 30% OFF FOR NEW ARRIVALS.",
    bg: 'F5FAFD',
  },
  {
    id: 2,
    img: require('./images/home/img1.png'),
    title: 'AUTUMN COLLECTION',
    desc: "DON'T COMPROMISE ON STYLE! GET FLAT 30% OFF FOR NEW ARRIVALS.",
    bg: 'fcf1ed',
  },
  {
    id: 3,
    img: require('./images/home/img1.png'),
    title: 'POPULAR COLLECTION',
    desc: "DON'T COMPROMISE ON STYLE! GET FLAT 30% OFF FOR NEW ARRIVALS.",
    bg: 'fbf0f4',
  },
];

export const categories = [
  {
    id: 1,
    img: require('./images/categories/1.png'),
    title: 'SHIRT STYLE!',
  },
  {
    id: 2,
    img: require('./images/categories/2.png'),
    title: 'LOUNGEWEAR LOVE',
  },
  {
    id: 3,
    img: require('./images/categories/3.png'),
    title: 'LIVE JACKETS',
  },
];

export const popularProducts = [
  {
    id: 1,
    img: require('./images/products/1.png'),
  },
  {
    id: 2,
    img: require('./images/products/2.png'),
  },
  {
    id: 3,
    img: require('./images/products/3.png'),
  },
  {
    id: 4,
    img: require('./images/products/4.png'),
  },
  {
    id: 5,
    img: require('./images/products/5.png'),
  },
  {
    id: 6,
    img: require('./images/products/6.png'),
  },
  {
    id: 7,
    img: require('./images/products/7.png'),
  },
  {
    id: 8,
    img: require('./images/products/8.png'),
  },
];
